import { render, staticRenderFns } from "./FileBionetUpload.vue?vue&type=template&id=fd32a4a0&"
import script from "./FileBionetUpload.vue?vue&type=script&lang=js&"
export * from "./FileBionetUpload.vue?vue&type=script&lang=js&"
import style0 from "./FileBionetUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports